import React, { useEffect, useState, Fragment } from "react";
import $ from "jquery";
import { trackPromise } from "react-promise-tracker";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { Checkbox } from "@material-ui/core";
import { LoadingMaterialTable } from "../../../../Common/table";
import services from "../services";
import tokenService from "../../../../Common/tokenDecoder";
import MessageModal from "../../../../UI/Modal/MessageModal";

export const EmployeeCardRegenerateListing = (props) => {
  const { cardRegenerateData, afterSuccessfulyChanged } = props;
  const [cardRegenerateFiltering, setCardRegenerateFiltering] = useState([]);
  const [saveData, setSaveData] = useState([]);
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed Success",
  });

  const [checkAll, setCheckAll] = useState(false);

  const selectAll = () => {
    setCheckAll(!checkAll);
  };


  useEffect(() => {
    trackPromise(setCardRegenerateData());
  }, [cardRegenerateData]);

  async function setCardRegenerateData() {
    await setCardRegenerateFiltering(cardRegenerateData);
  }

  function handleClick(data) {
    var token = tokenService.getUserDetailsFromToken();
    let cardData = {
      cardID: data.cardID,
      createdBy: parseInt(token.id),
    };

    let dataRecords = [...saveData];

    var isEnable = dataRecords.find((p) => p.cardID == data.cardID);
    if (isEnable === undefined) {
      dataRecords.push(cardData);
    } else {
      var index = dataRecords.indexOf(isEnable);
      dataRecords.splice(index, 1);
    }

    setSaveData(dataRecords);
  }

  async function handleSave(e) {
    e.preventDefault();
    const response = await services.updateStatus(saveData);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });
    afterSuccessfulyChanged(response.statusCode);
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function handleClickAll(e) {
    var token = tokenService.getUserDetailsFromToken();

    var cardDataCopy = [...saveData];

    if(e.target.checked) {
      cardRegenerateFiltering.forEach((x) => {
        let cardData = {
          cardID: x.cardID,
          createdBy: parseInt(token.id),
        };
        
        var isEnable = cardDataCopy.find((p) => p.cardID == x.cardID);
        if(isEnable === undefined) {
          cardDataCopy.push(cardData);
        }
      });
      setSaveData(cardDataCopy);
    } else {
      setSaveData([]);
    }
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <LoadingMaterialTable
        title=""
        columns={[
          {
            title:(
              <label>
                <Checkbox
                  color="primary"
                  onClick={(e) => handleClickAll(e)}
                  onChange={selectAll}
                  checked={cardRegenerateFiltering.length != 0 && saveData.length == cardRegenerateFiltering.length}
                ></Checkbox>
                Select All
              </label>
            ),
            sorting: false,
            field: "select",
            type: "boolean",
            render: (data) => (
              <Checkbox
                color="primary"
                onClick={() => handleClick(data)}
                checked={!(saveData.find((x) => x.cardID == data.cardID) == undefined)}
              ></Checkbox>
            ),
          },
          { title: "Card Number", field: "cardNumber" },
          { title: "Registration Number", field: "registrationNumber" },
          { title: "First Name ", field: "firstName" },
          { title: "Name to be Printed", field: "nameToBePrinted" },
          
        ]}
        data={cardRegenerateFiltering}
      />

      <div className="card-footer">
        <input
          type="submit"
          className="btn btn-primary pull-right"
          value="Regenerate"
          onClick={(e) => trackPromise(handleSave(e))}
        />
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
      />
    </Fragment>
  );
};
